<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="系统编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['number'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="合同号" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['contract_number'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="委托方" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['host_corporation'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="受托方" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="clientFetching ? undefined : null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'client_id',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="请输入"
                  @search="this.clientSearch"
                  @change="handleClientChange"
                >
                  <a-spin v-if="clientFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in clientList" :key="d.id">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="评估对象" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['evaluation_object', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="评估基准日" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  v-decorator="['valuation_reference_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="评估基准日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="服务费总额" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number style="width: 50%" allow-clear v-decorator="['total_service_fee', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="增值税率" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number allow-clear v-decorator="['rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/> %
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                自定义信息
              </a-divider>
            </a-col>
            <a-col :offset="2" :span="12">
              <a-button icon="plus" style="margin-bottom: 15px" @click="addOthers">添加</a-button>
            </a-col>
            <a-col :offset="2" :span="20" v-if="otherData.customizeInfo.length > 0">
              <a-table
                bordered
                :data-source="otherData.customizeInfo"
                :columns="othersColumns"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    title="确定删除?"
                    @confirm="() => onOthersDelete(record)">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                  <a-divider type="vertical"/>
                  <a @click="onOthersEdit(record)">编辑</a>
                </template>
              </a-table>
            </a-col>
          </a-row>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col offset="8" span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
      <create-others-form
        ref="createOthersForm"
        @cancel="handleAddOthersCancel"
        @ok="handleOthersOk"
        :visible="visibleOthersFrom"
        v-if="visibleOthersFrom"
        :loading="othersConfirmLoadingFrom"
        :model="otherInfo" />
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import {
  asset_appraisal_mandate_agreement_list,
  asset_appraisal_mandate_agreement_update
} from '@/api/trade_asset_appraisal_mandate_agreement'
import { client_list } from '@/api/trade_client'
import CreateOthersForm from '../modules/CreateOthersForm'
export default {
  name: 'TableEdit',
  components: {
    CreateOthersForm
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      data: {},
      otherInfo: undefined,
      visibleOthersFrom: false,
      othersConfirmLoadingFrom: false,
      loading: false,
      clientFetching: false,
      clientList: [],
      guarantee_period_start_date: undefined,
      guarantee_period_end_date: undefined,
      fields: ['number', 'import_export_type', 'name', 'client_id', 'evaluation_object', 'valuation_reference_date', 'total_service_fee', 'rate'],
      otherData: {
        attachment: [],
        customizeInfo: []
      },
      othersColumns: [
        {
          title: '名称',
          width: '100px',
          dataIndex: 'name'
        },
        {
          title: '内容',
          width: '200px',
          dataIndex: 'content'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '50px',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.loadContract()
  },
  computed: {
    isCommon () {
      return false
    }
  },
  methods: {
    moment,
    handleGoBack () {
      this.$router.go(-1)
    },
    addOthers () {
      this.visibleOthersFrom = true
    },
    loadContract () {
      this.loading = true
      asset_appraisal_mandate_agreement_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.otherData.customizeInfo = this.data.customize_info
          this.loadEditInfo(this.data)
          this.loadClient()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadClient () {
      client_list({ id: this.data.client_id }).then(res => {
        if (res.code === 1000) {
          this.clientList = res.data.entries || []
        }
      })
    },
    handleClientSearch (value) {
      this.clientFetching = true
      client_list({ name: value }).then(res => {
        if (res.code === 1000) {
          this.clientList = res.data.entries || []
        }
      }).finally(() => {
        this.clientFetching = false
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          this.loading = true
          values['customize_info'] = this.otherData.customizeInfo
          asset_appraisal_mandate_agreement_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      data.import_export_type = '' + data.import_export_type
      const formData = pick(data, this.fields)
      form.setFieldsValue(formData)
    },
    onOthersDelete (record) {
      const dataSource = [...this.otherData.customizeInfo]
      this.otherData.customizeInfo = dataSource.filter(item => item.key !== record.key)
    },
    onOthersEdit (record) {
      this.otherInfo = record
      this.visibleOthersFrom = true
      console.log('=============', this.otherInfo)
    },
    handleAddOthersCancel () {
      this.visibleOthersFrom = false
      const form = this.$refs.createOthersForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOthersOk (date) {
      const form = this.$refs.createOthersForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          let targetIndex = -1
          if (this.otherInfo !== undefined) {
            // 假设 customizeInfo 是一个数组，每个元素都有一个 key 字段
            targetIndex = this.otherData.customizeInfo.findIndex(item => item.key === this.otherInfo.key)
          }
          if (targetIndex !== -1) {
            // 找到对应 item，更新它
            // this.otherData.customizeInfo[targetIndex] = {
            //  key: this.otherInfo.key, name: values['name'], content: values['content']
            // }
            const updatedItem = {
              key: this.otherInfo.key,
              name: values['name'],
              content: values['content']
            }

            // 使用 $set 替换指定索引的元素
            // 参数说明：(目标数组, 索引位置, 新值)
            this.$set(this.otherData.customizeInfo, targetIndex, updatedItem)
          } else {
            // 如果没有找到，可以选择 push 进去（可选）
            const current_date = new Date()
            const timeKey = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            values['key'] = timeKey
            this.otherData.customizeInfo.push(values)
          }
          this.visibleOthersFrom = false
          this.othersConfirmLoadingFrom = false
          form.resetFields()
        }
      })
    }
  }
}
</script>
